import achievementsChoicer from './achivementsChoicer';
import imageGenerate from './imageGenerate';

(() => {
  const { sliders } = achievementsChoicer();
  imageGenerate(sliders);
})();
